/* tslint:disable */
/* eslint-disable */
/**
 * Prebooking service API
 * Service provides pre booking functionality for long term reservations.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * prebooking request
 * @export
 * @interface PartnerPrebookingRequest
 */
export interface PartnerPrebookingRequest {
    /**
     * 
     * @type {string}
     * @memberof PartnerPrebookingRequest
     */
    jwtToken: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPrebookingRequest
     */
    vehicleCategory: PartnerPrebookingRequestVehicleCategoryEnum;
    /**
     * 
     * @type {number}
     * @memberof PartnerPrebookingRequest
     */
    rentalStartsAtMillis: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPrebookingRequest
     */
    rentalEndsAtMillis: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerPrebookingRequest
     */
    language: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerPrebookingRequest
     */
    decodedOfferToken: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PartnerPrebookingRequest
     */
    selectedExtraIds: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof PartnerPrebookingRequest
     */
    locationId: number;
    /**
     * 
     * @type {number}
     * @memberof PartnerPrebookingRequest
     */
    partnerId: number;
}


/**
 * @export
 */
export const PartnerPrebookingRequestVehicleCategoryEnum = {
    M: 'M',
    L: 'L',
    XL: 'XL'
} as const;
export type PartnerPrebookingRequestVehicleCategoryEnum = typeof PartnerPrebookingRequestVehicleCategoryEnum[keyof typeof PartnerPrebookingRequestVehicleCategoryEnum];


/**
 * Check if a given object implements the PartnerPrebookingRequest interface.
 */
export function instanceOfPartnerPrebookingRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "jwtToken" in value;
    isInstance = isInstance && "vehicleCategory" in value;
    isInstance = isInstance && "rentalStartsAtMillis" in value;
    isInstance = isInstance && "rentalEndsAtMillis" in value;
    isInstance = isInstance && "language" in value;
    isInstance = isInstance && "decodedOfferToken" in value;
    isInstance = isInstance && "selectedExtraIds" in value;
    isInstance = isInstance && "locationId" in value;
    isInstance = isInstance && "partnerId" in value;

    return isInstance;
}

export function PartnerPrebookingRequestFromJSON(json: any): PartnerPrebookingRequest {
    return PartnerPrebookingRequestFromJSONTyped(json, false);
}

export function PartnerPrebookingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerPrebookingRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'jwtToken': json['jwtToken'],
        'vehicleCategory': json['vehicleCategory'],
        'rentalStartsAtMillis': json['rentalStartsAtMillis'],
        'rentalEndsAtMillis': json['rentalEndsAtMillis'],
        'language': json['language'],
        'decodedOfferToken': json['decodedOfferToken'],
        'selectedExtraIds': json['selectedExtraIds'],
        'locationId': json['locationId'],
        'partnerId': json['partnerId'],
    };
}

export function PartnerPrebookingRequestToJSON(value?: PartnerPrebookingRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'jwtToken': value.jwtToken,
        'vehicleCategory': value.vehicleCategory,
        'rentalStartsAtMillis': value.rentalStartsAtMillis,
        'rentalEndsAtMillis': value.rentalEndsAtMillis,
        'language': value.language,
        'decodedOfferToken': value.decodedOfferToken,
        'selectedExtraIds': value.selectedExtraIds,
        'locationId': value.locationId,
        'partnerId': value.partnerId,
    };
}

